import React, { useState } from 'react'
import { Outlet , Navigate } from 'react-router-dom'
import {useAuth} from "../../../usercontext";
import { ParentHeader } from "../header";
import ParentSidebar from "../sidebar";
import Footer from "../../footer";

export default function ParentLayout() {
   const [mobileMenu, setMobileMenu] = useState(false);

  const { profile } = useAuth();
  //console.log("Layout",profile);

  if(!profile || profile.role !== "Parent")
  return <Navigate to={"/login"} />

  return (
    <div className='main-wrapper'>
      <ParentHeader
        activeMenu={'Dashboard'}
        setMobileMenu={setMobileMenu}
        mobileMenu={mobileMenu}
      />
      <div className='page-content instructor-page-content'>
        <div className='d-flex justify-content-center'>
          <div className='row' style={{ width: '98%' }}>
            {/* Sidebar */}
            {/*}
            <ParentSidebar
              activeMenu={'Dashboard'}
              setMobileMenu={setMobileMenu}
              mobileMenu={mobileMenu}
            />
            
             */}
            <div className='col-xl-12 col-md-12'>
              <Outlet />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}
